import { put, call } from 'redux-saga/effects';
import type { PapiDeviation } from '@wix/da-papi-types';
import { requestPuppy } from '@wix/da-http-client';
import type { AxiosRequestConfig } from 'axios';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { pushGlobalConfirmationModalForMM } from '../../Modals/redux/actionCreators';
import { canMakeDeviationPremium } from '../helpers';
import { DeviationTypes } from '../../types/deviation';

export function* checkAndWarnIfDeviationsAreNotSupportedForPremium(deviations: PapiDeviation[]) {
  const hasUnsupportedDeviationSelected = deviations.some(
    deviation => !canMakeDeviationPremium(deviation)
  );

  if (hasUnsupportedDeviationSelected) {
    yield put(
      pushGlobalConfirmationModalForMM({
        titleTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.title',
        textTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.text',
        confirmBtnLabelTransKey: 'common.ok',
        withCancelButton: false,
        confirmBtnType: 'dark',
        icon: <Warning />,
      })
    );
    return true;
  }
  return false;
}

export function* fetch({
  url,
  params,
  method = 'get',
  fakeResponse,
  ...otherOptions
}: AxiosRequestConfig & {
  fakeResponse?: (options?: AxiosRequestConfig) => any;
}): any {
  const response = yield call(
    requestPuppy,
    {
      url,
      method,
      params,
      ...otherOptions,
    },
    fakeResponse
  );
  return response;
}

export const fakeResponseForType =
  (type: DeviationTypes | 'all_posts') =>
  ({ params }) => {
    if (process.env.NODE_ENV !== 'production') {
      const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
      if (window.doError) {
        return {
          error: 'invalid_request',
          error_description: 'Not logged in.',
          status: 'error',
        };
      }

      let items: PapiDeviation[];
      switch (type) {
        case 'all_posts':
          items = [
            ...deviationsByType.journal.slice(0, 5),
            ...deviationsByType.literature.slice(0, 5),
            ...deviationsByType.statuses.slice(0, 5),
            ...deviationsByType.commissions.slice(0, 5),
            ...deviationsByType.polls.slice(0, 5),
          ];
          break;
        case DeviationTypes.IMAGE:
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
        case DeviationTypes.FILM:
        case DeviationTypes.PDF:
          items = deviationsByType[type];
          break;
        case DeviationTypes.POLL:
          items = deviationsByType.polls;
          break;
        case DeviationTypes.COMMISSION:
          items = deviationsByType.commissions;
          break;
        case DeviationTypes.STATUS:
          items = deviationsByType.statuses;
          break;
        default:
          items = [];
      }
      const { offset, limit } = params;
      const randomDeviations = items.slice(offset, offset + limit);

      return {
        hasMore: offset + limit < items.length,
        nextOffset: offset + limit,
        results: randomDeviations,
      };
    }
  };
